import type { ReactNode } from 'react';
import { Box, Card, Heading, Icon, Paragraph, Popover, Spinner, Text } from '@zillow/constellation-10';
import { IconInfoFilled } from '@zillow/constellation-icons';
import { styled } from '@/styled-system/jsx';

const StyledCard = styled(Card, {
  base: {
    padding: '600',
    height: '100%',
    minHeight: '320px',
  },
  variants: {
    compact: {
      true: {
        minHeight: 'auto',
      },
    },
  },
});

type SectionCardProps = {
  title: string;
  children: ReactNode;
  'data-graph-id'?: string;
  tooltip?: string;
  loading?: boolean;
  compact?: boolean;
};

export const SectionCard = ({
  title,
  children,
  'data-graph-id': graphId,
  tooltip,
  loading,
  compact,
}: SectionCardProps) => {
  const heading = (
    <Heading level={5} css={{ marginBottom: '400' }}>
      {title}
    </Heading>
  );

  return (
    <StyledCard elevated={false} compact={compact} data-graph-id={graphId}>
      {tooltip ? (
        <Popover
          closeButton={<span hidden />}
          body={<Paragraph textStyle="body-sm">{tooltip}</Paragraph>}
          trigger={
            <Box css={{ display: 'inline-flex', cursor: 'pointer' }}>
              {heading}
              <Icon css={{ cursor: 'pointer', fill: 'icon.muted' }} size="sm">
                <IconInfoFilled />
              </Icon>
            </Box>
          }
          shouldAwaitInteractionResponse
          tone="neutral"
          header={<Text textStyle="body-sm-bold">{title}</Text>}
        />
      ) : (
        heading
      )}
      <Box css={{ height: 'calc(100% - 32px)', display: 'flex', flexDirection: 'column' }}>
        {loading ? (
          <Box css={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
            <Spinner size="md" />
          </Box>
        ) : (
          children
        )}
      </Box>
    </StyledCard>
  );
};
